<script lang="ts">
  /**
   * Shown in the dock until music starts. Browsers block sound until a click, so the visuals run
   * silently behind the app and one of these buttons turns the sound on.
   */
  import type { AppController } from '../../app/controller.svelte';
  import Icon from './Icon.svelte';

  let { ctl }: { ctl: AppController } = $props();
  let fileInput: HTMLInputElement;
  const caps = $derived(ctl.caps);
</script>

<div class="prompt" role="group" aria-labelledby="source-prompt-title" data-testid="source-prompt">
  <div class="title" id="source-prompt-title">Choose your music</div>
  <div class="buttons">
    <button
      class="primary"
      disabled={ctl.busy}
      data-testid="start-demo"
      onclick={() => ctl.start('demo')}><Icon name="play" /> Demo groove</button
    >
    {#if caps.microphone}
      <button disabled={ctl.busy} data-testid="start-mic" onclick={() => ctl.start('mic')}
        ><Icon name="mic" /> Microphone</button
      >
    {/if}
    <button disabled={ctl.busy} data-testid="start-file" onclick={() => fileInput.click()}
      ><Icon name="music" /> Files…</button
    >
    {#if caps.tabAudio}
      <button disabled={ctl.busy} data-testid="start-tab" onclick={() => ctl.start('tab')}
        ><Icon name="tab" /> Tab audio</button
      >
    {/if}
  </div>
  <div class="hint">Or drop files or a folder anywhere. Nothing is uploaded.</div>

  <input
    bind:this={fileInput}
    class="visually-hidden"
    aria-label="Choose files"
    type="file"
    accept="audio/*"
    multiple
    data-testid="file-input"
    onchange={(e) => {
      const files = [...(e.currentTarget.files ?? [])];
      e.currentTarget.value = '';
      if (files.length) void ctl.playFiles(files);
    }}
  />
</div>

<style>
  .prompt {
    pointer-events: auto;
    max-width: 100%;
    padding: 12px 14px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--panel);
    backdrop-filter: blur(12px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  }
  .title {
    font-weight: 600;
    margin-bottom: 8px;
  }
  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .hint {
    margin-top: 8px;
    font-size: 12px;
    color: var(--muted);
  }
</style>
